import React from 'react';
import { Box } from '@heycater/design-system';
import Head from 'next/head';

import MainLayout from 'shared/layouts/MainLayout';
import { fetchRatings } from 'shared/services/trustedShops/fetchRatings';
import FooterClean from 'static_pages/marketing_pages/components/FooterClean';
import PageSectionA from 'static_pages/marketing_pages/components/PageSectionA';
import PageSectionB from 'static_pages/marketing_pages/components/PageSectionB';
import PageSectionC from 'static_pages/marketing_pages/components/PageSectionC';
import SocialProofBar from 'static_pages/marketing_pages/components/SocialProofBar';
import Testimonials from 'static_pages/marketing_pages/components/Testimonials';
import TrustedCustomers from 'static_pages/marketing_pages/components/TrustedCustomers';
import Hero from 'static_pages/marketing_pages/customer_landing_page/components/Hero';
import RequestSection from 'static_pages/marketing_pages/customer_landing_page/components/RequestSection';
import StepsToCatering from 'static_pages/marketing_pages/customer_landing_page/components/StepsToCatering';
import Container from 'system/components/Container';

function CustomerLandingPage({ page, ratings }) {
  return (
    <MainLayout ratings={ratings}>
      <Head>
        <title>{page.metaTitle}</title>
        <meta name="description" content={page.metaDescription} />
        <meta property="og:title" content={page.metaTitle} />
        <meta property="og:description" content={page.metaDescription} />
      </Head>

      <Hero
        title={page.heroTitle}
        titleBottom={page.heroTitleBottom}
        subtitle={page.heroSubtitle}
        headerImage={page.headerImage}
      />

      <SocialProofBar />

      <Container size="md">
        <PageSectionA
          header={page.section1Header}
          body={page.section1Body}
          image={page.section1Image}
        />

        <StepsToCatering
          cta={page.stepsToCateringCta}
          link={page.stepsToCateringCtaLink}
        />
      </Container>

      <TrustedCustomers title={'customerLandingPage.trustedBy'} />

      <Container size="md">
        <Box mt={{ xs: 6, sm: 10 }}>
          <PageSectionC
            header={page.section2Header}
            subtitle={page.section2Subtitle}
            content={page.section2ContentBlock}
            cta={page.section2Cta}
            link={page.section2CtaLink}
          />
        </Box>

        <PageSectionB
          header={page.section3Header}
          content={page.section3ContentBlock}
          cta={page.section3Cta}
          link={page.section3CtaLink}
        />

        <Testimonials
          header={page.section4Header}
          content={page.section4ContentBlock}
        />

        <RequestSection />
      </Container>

      <FooterClean
        title={'customerLandingPage.footerTitle'}
        cta={'customerLandingPage.footerCta'}
        link={'start'}
      />
    </MainLayout>
  );
}

export async function getStaticProps() {
  const ratings = await fetchRatings();
  return {
    props: {
      robots: 'none',
      ratings,
    },
  };
}

export default CustomerLandingPage;
